import { configureStore } from '@reduxjs/toolkit';
import pavFormReducer from '../features/pav-form/PavFormSlice'

export default configureStore({
  reducer: {
    pavForm: pavFormReducer, 
  },
});
